import { ServiceLocator } from '../../app/ServiceLocator';
import { IListFetcher } from '../fetchers/IListFetcher';
import { ListResult } from '../fetchers/ListResult';
import { IIdItemInfo } from '../models/resourceInfoParts';
import { ExploreContentApi_ContentType } from '../ServerApi/types/IContent';
import { IFavorite } from '../ServerApi/types/IFavorite';
import { ILeafFilterClause } from '../ServerApi/types/IFilterClause';
import { IOrderClause } from '../ServerApi/types/IOrderClause';
import { Favorites } from '../../content/resources/Favorites';
import { IResourceQuery } from './ResourceQuery';

//
// Given a ResourceQuery object that fetches a certain content type
// Fetch favorites in given position sort order and then
// sort the content items based on the favorites order
//
export class GetContentInFavoritesOrderResource<T extends IIdItemInfo> implements IResourceQuery<T> {

  private maxSlice = 1000;
  private contentQuery: IResourceQuery<T>;

  public constructor(
    contentQuery: IResourceQuery<T>,
    private targetContentType: ExploreContentApi_ContentType,
    private order: IOrderClause,
  ) {
    this.contentQuery = contentQuery.withOrder([]);
  }

  public getCount(): ng.IPromise<number> {
    return this.contentQuery.getCount();
  }

  public getSlice(): ng.IPromise<ListResult<T>> {
    const $q = ServiceLocator.get<ng.IQService>('$q');
    const favoritesQuery = Favorites.allForTypesAndSort([ this.targetContentType ], [ this.order ]);

    return $q.all([
      this.contentQuery.getSlice(0, this.maxSlice),
      favoritesQuery.getSlice(0, this.maxSlice)
    ]).then((result) => {
      this.sortByFavoritesOrder(result);
      return $q.resolve(result[0]);
    });
  }

  public sortByFavoritesOrder(result: [ListResult<T>, ListResult<IFavorite>]): void {
    const itemsResult = result[0];
    const favoritesResult: ListResult<IFavorite> = result[1];
    let itemsIndex = 0;
    favoritesResult.items.forEach((fav: IFavorite) => {
      for(let i = itemsIndex; i<itemsResult.items.length; i++) {
        if (fav.objectId === itemsResult.items[i].id) {
          const temp = itemsResult.items[i];
          itemsResult.items[i] = itemsResult.items[itemsIndex];
          itemsResult.items[itemsIndex] = temp;
          itemsIndex++;
        }
      }
    });
  }

  // noop functions need to match IResourceQuery interface
  public getFilters(): ILeafFilterClause[] { return []; }
  public getFirst() { return null as ng.IPromise<T>; }
  public getOrder(): IOrderClause[] { return []; }
  public getFetcher(): IListFetcher<T> { return null; }
  public getExtraParams(): any { return null; }
  addFilter(filterClause: ILeafFilterClause): IResourceQuery<T> { return this; }
  withFilters(filterClauses: ILeafFilterClause[]): IResourceQuery<T> { return this; }
  withOrder(order: IOrderClause[]): IResourceQuery<T> { return this; }
  withFiltersAndOrder(filterClauses: ILeafFilterClause[], order: IOrderClause[]): IResourceQuery<T> { return this; }
  withExtraParams(extraParams?: any): IResourceQuery<T> { return this; }
}
